import styled from "styled-components";


export const ContactBox = styled.div` 

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 1%;

`;

export const ContactIcon = styled.img`

    width: 30px;
    height: 30px;
    object-fit: contain;
    margin: 10px;
    &:hover {
        background-color: grey;
        border-radius: 16px;
    }
`;